import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-header-logo',
    templateUrl: './header-logo.component.html',
    styleUrls: [
        './header-logo.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderLogoComponent
{
    constructor() { }
}
